export const CARD_TRACKING_HOME_LIMIT = 2;
export const CARD_TRACKING_LIST_LIMIT = 20;
export function sortTrackingCardsByCreatedAtDesc(cards) {
    return [...cards].sort((left, right) => {
        const leftTime = Date.parse(left.createdAt);
        const rightTime = Date.parse(right.createdAt);
        const safeLeft = Number.isNaN(leftTime) ? 0 : leftTime;
        const safeRight = Number.isNaN(rightTime) ? 0 : rightTime;
        return safeRight - safeLeft;
    });
}
export function getNewestTrackingCards(cards, limit) {
    return sortTrackingCardsByCreatedAtDesc(cards).slice(0, limit);
}
export function filterTrackingCardsByCode(cards, searchTerm) {
    const normalized = searchTerm.trim().toLowerCase();
    if (!normalized) {
        return cards;
    }
    return cards.filter(card => card.trackingCode.toLowerCase().includes(normalized));
}
